import './default_module' // undo this when all the project pages are themed

/* stylesheet */
import 'stylesheets/projects/show.scss'

const project_locations_initialize = function() {

  const mapOptions = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    draggable: false,
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    styles: [
      {
        "featureType": "water",
        "stylers": [
          { "color": "#F5F5F5" }
        ]
      },{
        "featureType": "road",
        "stylers": [
          { "visibility": "off" }
        ]
      },{
        "featureType": "landscape",
        "stylers": [
          { "visibility": "off" }
        ]
      }
    ]
  };

  if ($("#map-canvas").length > 0) {
    const map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
    project_set_up_map(map);
  }
  if ($("#map-canvas-edit").length > 0) {
    const map_edit = new google.maps.Map(document.getElementById("map-canvas-edit"), mapOptions);
    return project_set_up_map(map_edit);
  }
};

const project_set_up_map = function(map) {
  const infowindow = new google.maps.InfoWindow();
  const bounds = new google.maps.LatLngBounds();

  const svgMarker = {
    path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
    fillColor: "#FFCC00",
    fillOpacity: 1,
    strokeWeight: 0.5,
    strokeColor: "#08090D",
    rotation: 0,
    scale: 2,
    anchor: new google.maps.Point(15, 30),
  };

  $(".location-data").each(function() {
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng($(".location-lat", this).text(), $(".location-long", this).text()),
      labelClass: "location-labels",
      icon: svgMarker,
      map
    });
    bounds.extend(marker.position);
    const label = $(".location-label", this).text();
    return google.maps.event.addListener(marker, 'mouseover', function() {
      infowindow.setContent(label);
      return infowindow.open(map, marker);
    });
  });

  if ($(".locations-data .location-data").length === 1) {
    map.setCenter(bounds.getCenter());
    return map.setZoom(9);
  } else {
    return map.fitBounds(bounds);
  }
};

jQuery(function() {

  if (window.google && window.google.maps) {
    project_locations_initialize();
  }

});